strap-checkboxes
  .checkboxes(class="{ props.type } { props.mobile ? 'sp' : 'pc' }")
    template(each="{(strapMaster, index) in state.strapMasters}")
      label
        template(if="{ props.type === 'in_modal' }")
          img(src="{checkboxOnIcon}" class="checkbox-icon { state.straps.includes(strapMaster.strap) ? '' : 'hidden' }")
          img(src="{checkboxOffIcon}" class="checkbox-icon { state.straps.includes(strapMaster.strap) ? 'hidden' : '' }")
        input(type="checkbox" onchange="{didChangeStrap}" name="st[{index}]" value="{ strapMaster.strap }"
              checked="{ state.existStrap.includes(strapMaster.strap) }")
        | { strapMaster.text }
  style(type="scss").
    .checkboxes {
      display: flex;
      flex-wrap: wrap;
      &.in_sidebar {
        margin-top: 10px;
        label {
          width: 100%;
          border-top: 3px solid #e8e8e8;
          padding: 12px 8px;
          &:last-child {
            border-bottom: 3px solid #e8e8e8;
          }
          input {
            margin-right: 7px;
          }
        }
        &.pc {
          label {
            a {
              font-size: 12px;
              &:hover {
                text-decoration: underline;
              }
            }
          }
        }
        &.sp {
          margin-top: 16px;
          label {
            border-top-width: 2px;
            font-size: 15px;
            display: flex;
            align-items: center;
            padding: 12px 13px;
            input {
              margin-right: 4px;
            }
            &:last-child {
              border-bottom-width: 2px;
            }
          }
        }
      }
      &.in_modal {
        row-gap: 11.25vw;
        label {
          width: 50%;
          color: #6c6c6c;
          font-size: 4.6875vw;
          font-weight: 700;
          display: flex;
          align-items: center;
          input {
            display: none;
          }
          .checkbox-icon {
            height: 6.40625vw;
            width: 6.40625vw;
            margin-right: 1.25vw;
            &.hidden {
              display: none;
            }
          }
        }
      }
    }
  script.
    import checkboxOnIcon from 'tags/smartsearch/checkbox_t.png'
    import checkboxOffIcon from 'tags/smartsearch/checkbox_f.png'
    import SmartsearchMaster from 'models/smartsearch-master.js'

    export default {
      checkboxOnIcon,
      checkboxOffIcon,
      onBeforeMount(props, state) {
        const masterData = new SmartsearchMaster()
        state.strapMasters = masterData.strapMasters
        state.strapValues = state.strapMasters.map(current => current.strap)

        state.existStrap = []
        state.straps = []
      },
      didChangeStrap() {
        const strapElements = this.root.querySelectorAll('.checkboxes input')
        const straps = Array.prototype.map.call(strapElements, (c) => {
          return c.checked ? c.value : ''
        }).filter(strap => strap.length > 0)
        const strapQuery = straps.join(',')
        this.update({
          strapQuery,
          straps
        })
        this.props.onUpdate(strapQuery)
      },
      initializeByExistQuery() {
        const result = (new RegExp('[?&]'+encodeURIComponent('st')+'=([^&]*)')).exec(location.search)
        if(!result) return

        const existStrap = decodeURIComponent(result[1]).split(',')
        this.update({
          existStrap,
          straps: existStrap
        })
      },
      urlFromValueWithFormData(value) {
        const queryKey = 'st'
        if (!this.props.formdata) return

        const formDataObj = Object.fromEntries(Array.from(this.props.formdata.entries()))

        const currentValues = (this.state.strapQuery || '').split(',')
        if (!currentValues.includes(value)) {
          const values = Array.from(this.state.strapValues).filter( v => (currentValues.includes(v) || value == v) )
          formDataObj[queryKey] = values.join(',')
        }
        const formDataArray = Array.from(Object.entries(formDataObj)).sort( (kv1, kv2) => {
          if (kv1 < kv2) { return -1 }
          else if (kv1 > kv2) { return 1 }
          else return 0
        })
        const url = '/watches/?' + formDataArray.filter( kv => !!kv[1] ).map( kv => kv[0] + '=' + kv[1] ).join('&')
        return url
      },
      onMounted(props, state) {
        this.initializeByExistQuery()
        this.update()
      },
    }
